module.exports = __webpack_public_path__ + "static/img/mr-bot-static-sm-optimized.7428f16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mr-bot-static-sm-optimized.png
// module id = 570
// module chunks = 1